import React, { useContext, useEffect, useRef } from "react";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import classNames from "classnames";

import InfoMessage from "@components-shared/InfoMessageComponent";
import Currency from "@components-shared/Currency";
import { MyBetsStoreContext } from "@state/context/my-bets/MyBetsStoreContext";

export default observer(function ModalBody() {
	const thresholdInputRef = useRef<HTMLInputElement>(null);

	const { t } = useTranslation();
	const store = useContext(MyBetsStoreContext)?.cashoutStore;

	useEffect(() => {
		const timer = setTimeout(() => {
			thresholdInputRef.current?.focus();
		}, 1);
		return () => clearTimeout(timer);
	}, []);

	if (!store) {
		console.error("Expected store, got null");
		return null;
	}

	if (store.isAutosellModalCashedOut) {
		return (
			<InfoMessage
				type="success"
				message={t("mybets:SUCCESS_MESSAGE", {
					amount: store.autosellModalCashoutGain,
					currency: App.state.rootStore.userAuthStore.currency,
				})}
			/>
		);
	} else if (store.isAutocashoutUnavailable) {
		return (
			<>
				{store.isConfigurationExists && store.secureWinAmount && (
					<div className="form__field">
						<label
							htmlFor="definedAutoCashoutAmount"
							className="label"
						>
							{t("mybets:CASHOUT.SECURE_WIN_DESCRIPTION")}
						</label>
						<input
							id="definedAutoCashoutAmount"
							className="input input--base"
							type="number"
							value={store.secureWinAmount}
							disabled
						/>
					</div>
				)}
				<InfoMessage
					type="warning"
					message={t("mybets:CASHOUT.AUTO_CASHOUT_UNAVAILABLE")}
				/>
			</>
		);
	} else {
		return (
			<>
				<div className="form__field">
					<label htmlFor="setAutoCashoutAmount" className="label">
						{t("mybets:CASHOUT.SECURE_WIN_DESCRIPTION")}:
					</label>
					<input
						id="setAutoCashoutAmount"
						className={classNames("input input--base", {
							"input-validation-error":
								!store.isAutosellFormValid,
						})}
						type="number"
						step=".01"
						min="0"
						value={store.secureWinAmount || ""}
						onChange={(e) => store.handleChange(e.target.value)}
						ref={thresholdInputRef}
					/>
				</div>
				<div className="form__field u-mar--bottom--reset u-type--sml">
					<div
						className={classNames("row", {
							"u-color--text--primary--secondary":
								store.isMinThresholdValid,
							"u-color--sent--danger": !store.isMinThresholdValid,
						})}
					>
						<div className="col col-sml-6">
							{t("mybets:CASHOUT.MIN")}:
						</div>
						<div className="col col-sml-6 u-type--right">
							{store.minThreshold} <Currency component="span" />
						</div>
					</div>
					<div
						className={classNames("row", {
							"u-color--text--primary--secondary":
								store.isMaxThresholdValid,
							"u-color--sent--danger": !store.isMaxThresholdValid,
						})}
					>
						<div className="col col-sml-6">
							{t("mybets:CASHOUT.MAX")}:
						</div>
						<div className="col col-sml-6 u-type--right">
							{store.maxThreshold} <Currency component="span" />
						</div>
					</div>
				</div>
			</>
		);
	}
});
